import NoDataAvailableMessage from '@/src/components/home/no-data-available-message/NoDataAvailableMessage'
import { useQuery } from '@tanstack/react-query'
import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { userPreferencesPort } from '@/infra/config/beans'
import FamilyCard from '@/src/components/global/family-card/FamilyCard'
import { t } from 'i18next'
import { useNavigate } from 'react-router'
import FamilyCardListSkeleton from '@/src/components/global/family-card-list-skeleton/FamilyCardListSkeleton'
import { getDiagnoses } from '@/infra/api/generated/diagnoses/diagnoses'

const { getInProgressDiagnoses } = getDiagnoses()
import { trackEvent } from '@/src/analytics/amplitude'

const Index = () => {
  const navigate = useNavigate()
  const { store, team } = useUserPreferences(userPreferencesPort)
  const { data: diagnoses, isFetching } = useQuery({
    queryKey: ['diagnoses', 'in-progress', store?.id, team?.id],
    enabled: Boolean(store) && Boolean(team),
    queryFn: () => getInProgressDiagnoses(store!.id, team!.id),
  })

  if (diagnoses?.length === 0) {
    return (
      <div className="w-full flex justify-center items-center">
        <NoDataAvailableMessage />
      </div>
    )
  }

  const handleFamilyCardButtonClick = (diagnosisId: string) => {
    trackEvent('CONTINUE_DIAGNOSIS_BUTTON_CLICK', { diagnosisId })
    void navigate(`/diagnoses/${diagnosisId}/questions`)
  }

  return (
    <div className="w-full flex flex-col gap-3">
      {isFetching && <FamilyCardListSkeleton skeletonCount={2} />}
      {!isFetching &&
        diagnoses?.map((diag) => (
          <FamilyCard
            data-testid="in-progress-diagnosis-card"
            key={diag.diagnosisId}
            family={diag.family}
            completionPercentage={diag.completionPercentage}
            date={diag.startedAt}
            buttonProps={{
              label: t('global.continue'),
              onClick: () => handleFamilyCardButtonClick(diag.diagnosisId),
            }}
          />
        ))}
    </div>
  )
}

export default Index
